import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 p-4" }
const _hoisted_4 = { class: "default-table-area style-two all-projects" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle" }
const _hoisted_7 = { class: "text-body" }
const _hoisted_8 = {
  href: "#",
  class: "d-flex align-items-center"
}
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-grow-1 ms-2 position-relative top-2" }
const _hoisted_12 = { class: "mb-0 fs-14 fw-medium text-secondary" }
const _hoisted_13 = { class: "fs-13 text-body" }
const _hoisted_14 = { class: "text-body" }
const _hoisted_15 = { class: "text-body" }
const _hoisted_16 = { class: "text-body" }
const _hoisted_17 = { class: "text-body" }
const _hoisted_18 = { class: "ps-0 mb-0 list-unstyled d-flex gap-1" }
const _hoisted_19 = {
  key: 0,
  class: "badge bg-primary bg-opacity-10 text-primary p-2 fs-12 fw-normal"
}
const _hoisted_20 = {
  key: 1,
  class: "badge bg-danger bg-opacity-10 text-danger p-2 fs-12 fw-normal"
}
const _hoisted_21 = { class: "p-4 pt-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "position-relative table-src-form me-0",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            placeholder: "Search here",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "material-symbols-outlined position-absolute top-50 start-0 translate-middle-y" }, " search ", -1))
        ], 32),
        _cache[3] || (_cache[3] = _createElementVNode("button", {
          class: "btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#addNewInstructorsModal",
          "aria-controls": "addNewInstructorsModal"
        }, [
          _createElementVNode("span", { class: "py-sm-1 d-block" }, [
            _createElementVNode("i", { class: "ri-add-line d-none d-sm-inline-block me-1" }),
            _createElementVNode("span", null, "Add New Instructors")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "ID"),
                _createElementVNode("th", { scope: "col" }, "Name"),
                _createElementVNode("th", { scope: "col" }, "Courses"),
                _createElementVNode("th", { scope: "col" }, "Total Earnings"),
                _createElementVNode("th", { scope: "col" }, "Email"),
                _createElementVNode("th", { scope: "col" }, "Ratings"),
                _createElementVNode("th", { scope: "col" }, "Status"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-end"
                }, "Action")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.id
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.id), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("a", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: item.user.image,
                          class: "wh-44 rounded-circle",
                          alt: "user"
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h6", _hoisted_12, _toDisplayString(item.user.name), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item.user.designation), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(item.courses), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(item.totalEarnings), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(item.email), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("ul", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.ratings, (stars, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("i", {
                            class: _normalizeClass([stars.star, "text-rating-color fs-16"])
                          }, null, 2)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    (item.status.active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Active "))
                      : _createCommentVNode("", true),
                    (item.status.deactive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Deactive"))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                    _createElementVNode("div", { class: "d-flex justify-content-end align-items-center gap-1" }, [
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-primary" }, " visibility ")
                      ]),
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-body" }, " edit ")
                      ]),
                      _createElementVNode("button", { class: "ps-0 border-0 bg-transparent lh-1 position-relative top-2" }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-16 text-danger" }, " delete ")
                      ])
                    ])
                  ], -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Pagination, {
            items: "10",
            total: "30"
          })
        ])
      ])
    ])
  ]))
}